// extracted by mini-css-extract-plugin
module.exports = {"TabsWrapper":"TabSwitcher_TabsWrapper__vAev7","ButtonWrapper":"TabSwitcher_ButtonWrapper__3gkIg"};